<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import AdvanceTable from "../tables/componentAdvanceTable";
//import Basic from "./basic";
import axios from "axios";

import {
  required,
  //email,
  minLength,
  //sameAs,
  maxLength,
  //minValue,
  //maxValue,
  //numeric,
  //url,
  //alphaNum
} from "vuelidate/lib/validators";

/**
 * Form validation component
 */
export default {
  page: {
    title: "Customer",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, AdvanceTable/*Basic*/ },
  props:{
    id:[Number,null],
  },
  data() {
    return {
      info: null,
      title: "Customer registration",
      componentKey: 0,
      num_latitude: 0.0,
      num_longitude: 0.0,
      url_file: '',
      url_logo: '',
      items: [
        {
          text: "Management",
          href: "/"
        },
        {
          text: "Customers",
          href: "/management/customers"
        },
        {
          text: "Customer",
          active: true
        }
      ],
      industries: [],
      customerLocations: [],
      customerContacts: [],
      customerLocationsColumns: [
        {label: "ID",       field:"id_customerLocation",  key:"id_customerLocation",  sortable:"true"},
        {label: "State",    field:"nm_state",             key:"nm_state",             sortable:"true"},
        {label: "City",     field:"nm_city",              key:"nm_city",              sortable:"true"},
        {label: "Address",  field:"de_address",           key:"de_address",           sortable:"true"},
        {label: "Zip Code", field:"num_zipCode",          key:"num_zipCode",          sortable:"true"},
        {label: "Actions",  field:"action",               key:"actions",              tdClass:"actionsFixed"},
      ],
      customerContactsColumns: [
        {label: "ID",       field:"id_customerContact",       key:"id_customerContact",         sortable:"true"},
        {label: "Name",     field:"nm_contact",               key:"nm_contact",                 sortable:"true"},
        {label: "Email",    field:"de_contactEmail",          key:"de_contactEmail",            sortable:"true"},
        {label: "Phone",    field:"num_contactPhoneNumber",   key:"num_contactPhoneNumber",     sortable:"true"},
        {label: "License",  field:"num_contactLicenseNumber", key:"num_contactLicenseNumber",   sortable:"true"},
        {label: "Actions",  field:"action",                   key:"actions",                    tdClass:"actionsFixed"},
      ],
      form: {
        id_industry:        "",
        nm_customer:        "",
        num_licenseNumber:  "",
        sn_thirdParty:      false,
      },
      actions:{view:false, edit:true},
      submitted: false,
    };
  },
  validations: {
    form: {
      id_industry:        { required },
      nm_customer:        { required, minLength: minLength(2), maxLength: maxLength(200) },
      num_licenseNumber:  { required },
      sn_thirdParty:      { required },
    }
  },
  watch:{
    
  },
  created(){
    this.getIndustries();

    if( this.$route.params.id ){
      this.form['id_customer'] = this.$route.params.id;
      this.getCustomerByID(this.$route.params.id);
      this.getCustomerLocationsByCustomerID(this.$route.params.id);
      this.getCustomerContactsByCustomerID(this.$route.params.id);
    }
  },
  mounted() {
    
  },
  methods: {
    handleFile(){
      this.url_file = this.$refs.url_logo.files[0];
    },

    getIndustries(){
      let app = this;

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/industries.php',
        {
          params: {
            request: 'getIndustries',
          }
        }
      )
      .then(response => {
        
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.industries  = response.data
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal.fire('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },

    getCustomerLocationsByCustomerID(){
      let app = this;

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/customers.php',
        {
          params: {
            request:      'getCustomerLocationsByCustomerID',
            idCustomer:   app.$route.params.id
          }
        }
      )
      .then(response => {
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.customerLocations = response.data;
          }else{
            Swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          Swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },

    getCustomerContactsByCustomerID(){
      let app = this;

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/customers.php',
        {
          params: {
            request:      'getCustomerContactsByCustomerID',
            idCustomer:   app.$route.params.id
          }
        }
      )
      .then(response => {
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.customerContacts = response.data;
          }else{
            Swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          Swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },

    getCustomerByID(idCustomer){
      let app = this;

      Swal.fire({
        title: "Loading customer data.",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/customers.php',
        {
          params: {
            request:  'getCustomerByID',
            id:       idCustomer
          }
        }
      )
      .then(response => {
        //Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.form.id_industry                = response.data.id_industry;
            app.form.nm_customer                = response.data.nm_customer;
            app.form.num_licenseNumber          = response.data.num_licenseNumber;

            if(response.data.sn_thirdParty == 1){
              this.form.sn_thirdParty = true;
            }else{
              this.form.sn_thirdParty = false;
            }

            if(response.data.url_logo != ''){
              app.url_logo                  = window.serverPath+'dist'+response.data.url_logo;
            }
          }else{
            Swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          Swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },

    // eslint-disable-next-line no-unused-vars
    saveProduct(e) {
      let app = this;

      let formData = new FormData();

      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      
      if( !this.$v.form.$error ){
        if( this.$route.params.id ){
          this.form.id_customer = this.$route.params.id;
          console.log(this.form.id_customer);
        }

        if(this.form.sn_thirdParty){
          this.form.sn_thirdParty = 1;
        }

        Swal.fire({
          title: "Saving customer.",
          showConfirmButton:false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });

        //Appending the request, file and data to the formData object to be send all in a single request.
        formData.append('request',  'saveCustomer');
        formData.append('url_file',  app.url_file);
        formData.append('data',     JSON.stringify(app.form) );

        //Axios post with multipart/form-data header, so that backend knows there is a file to be handled.
        axios.post(
          window.serverPath+'dist/mvw/controllers/customers.php',
          formData,
          {
            headers: {'Content-Type': 'multipart/form-data'}
          }
        )
        .then(response => {
          if( response.statusText == "OK" ){
            if( response.data.Error){
              Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br><i>'+response.data.Error+'.</i><br><br>Please try again.</b></p>','error');
            }else{
              Swal.fire('Congrats!!!','<p><b>You have saved a new Customer.</b></p>','success')
              .then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                //app.$router.push({ name: 'industries'});
                app.id_customer = response.data;
                app.$router.push({ name: 'customers' });
              }
            });
            }
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        })
        .catch(function (error) {
          app.isLoading = false;
          if(
            error.code == "ERR_BAD_RESPONSE"    ||
            error.code == "ERR_NETWORK"
          ){
            Swal.fire('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
          }
        });
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />


    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form class="needs-validation" @submit.prevent="saveProduct">
              <div class="row">
                <div class="col-lg-4" style="border-right: solid 1px #ededed;">
                  <div class="row">
                    <div class="col-md-12">
                      <h4 class="card-title">Customer Industry Information</h4>
                      <p class="card-title-desc">Provide all information related to your customer.</p>
                      <div class="form-group">
                        <label for="id_industry">Industry</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_industry.$error }"
                          name="id_industry"
                          id="id_industry"
                          v-model="form.id_industry"
                        >
                          <option value="">SELECT YOUR INDUSTRY</option>
                          <option v-for="(industry, index) in industries" :key="index" :value="industry.id_industry">{{industry.nm_industry}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_industry.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_industry.required">Industry field is required.</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12 mt-5">
                      <h4 class="card-title">Customer General Information</h4>
                      <p class="card-title-desc">Provide all information related to your customer.</p>

                      <div class="form-group">
                        <label for="nm_customer">Customer name</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.nm_customer.$error }"
                          name="nm_customer"
                          id="nm_customer"
                          v-model="form.nm_customer"
                          value=""
                        >
                        <div v-if="submitted && $v.form.nm_customer.$error" class="invalid-feedback">
                          <span v-if="!$v.form.nm_customer.required">Customer name is required.</span>
                          <span v-if="!$v.form.nm_customer.minLength">This value length is invalid. It should be between 2 and 200 characters long.</span>
                          <span v-if="!$v.form.nm_customer.maxLength">This value length is invalid. It should be between 2 and 200 characters long.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="num_licenseNumber">License Number</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.num_licenseNumber.$error }"
                          name="num_licenseNumber"
                          id="num_licenseNumber"
                          v-model="form.num_licenseNumber"
                          value=""
                        >
                        <div v-if="submitted && $v.form.num_licenseNumber.$error" class="invalid-feedback">
                          <span v-if="!$v.form.num_licenseNumber.required">License number name is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <b-form-checkbox v-model="form.sn_thirdParty" switch class="mb-1">
                          <label>Is it a Third Party customer?</label>
                        </b-form-checkbox>
                      </div>

                      <div class="form-group">
                        <label for="company-logo">Customer logo</label>
                        <input id="company-logo" class="form-input w-full" type="file" ref="url_logo" accept=".png, .jpg, .jpeg" @change="handleFile"/>
                      </div>

                      <div v-if="url_logo != ''" class="form-group">
                        <img v-if="url_logo != ''" :src="url_logo" class="avatar-md" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-12 mt-5">
                      <div class="form-group text-center">
                        <button class="btn btn-success" type="submit">SAVE CUSTOMER</button>
                        <router-link to="/management/products" class="ml-3">
                          <button class="btn btn-danger" type="reset">CANCEL </button>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-8">
                  <div class="row">
                    <div class="col-md-12">
                      <AdvanceTable
                        :menu="'Management'"
                        :entity="'location'"
                        :addLink="'/management/locations'"
                        :modalType="'modal'"
                        :component="'CustomerLocation'"
                        :idEntity="form.id_customer"
                        @reload="getCustomerLocationsByCustomerID"
                        :datas="customerLocations"
                        :columns="customerLocationsColumns"
                        :actions="actions"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <AdvanceTable
                        menu="'Management'"
                        :entity="'contact'"
                        :addLink="'/management/contacts'"
                        :modalType="'modal'"
                        :component="'CustomerContact'"
                        :idEntity="form.id_customer"
                        @reload="getCustomerContactsByCustomerID"
                        :datas="customerContacts"
                        :columns="customerContactsColumns"
                        :actions="actions"
                      />
                    </div>
                  </div>
                </div>

                <!--
                <div class="col-lg-4"> 
                </div>
                -->
              </div>

              <!--
              <div class="row">
                <div class="col-lg-12 mt-5 pt-5">
                  <div class="form-group text-center">
                    <button class="btn btn-success" type="submit">SAVE PRODUCT</button>
                    <router-link to="/management/products" class="ml-3">
                      <button class="btn btn-danger" type="reset">CANCEL </button>
                    </router-link>
                  </div>
                </div>
              </div>
              -->
          </form>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>